<div class="tabs-container">
	<div class="selected-tab-content">
		<ng-container *ngFor="let tab of constructedTabs">
			<!-- use hidden here, so that the tab won't be destroyed when switching -->
			<div [hidden]="tab!==selectedTab" style="height:100%;width:100%;">
				<ng-container *ngTemplateOutlet="tab.template"></ng-container>
			</div>
		</ng-container>
	</div>
	<div class="tab-labels-section">
		<!-- <div class="phony-border"></div> -->
		<div class="label-group">
			<ng-container *ngFor="let tab of tabs; let idx = index">
				<div *ngIf="!tab.hidden&&!tab.tempHidden"
					class="label-item" [ngClass]="{'selected-tab-label': selectedTab === tab, 'disable-switching-label': disableSwitchingTab}"
					title="{{tab.tooltip||''}}"
					(click)="selectTab(idx)">
					<div *ngIf="!tab.isLabelIcon" class="label-item-inner">{{tab.label}}</div>
					<div *ngIf="tab.isLabelIcon" class="label-item-inner">
						<i [class]="tab.label"></i>
					</div>
				</div>
			</ng-container>
		</div>
	</div>
</div>